import { render } from "./complaintlist.vue?vue&type=template&id=72cb6da4&scoped=true"
import script from "./complaintlist.vue?vue&type=script&lang=js"
export * from "./complaintlist.vue?vue&type=script&lang=js"

import "./complaintlist.vue?vue&type=style&index=0&id=72cb6da4&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cb6da4"]])

export default __exports__